module.exports = __webpack_public_path__ + "img/super-water-slide--icon--gray.6d3ad3e0.svg";